module.exports = __webpack_public_path__ + "static/vladimir-putin-71ebf8f2d8335cd823470cf3d38e1481.jpg";